import React from "react";
import "../styles/Featured.css";

const Featured = ({ title, media, backgroundImage, titleColour, isHero, customContent }) => {
  const sectionClasses = `featured${isHero ? ' featured-hero' : ''}`;

  return (
    <section
      className={sectionClasses}
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: isHero ? "cover" : "100% auto",
        backgroundPosition: "bottom center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="featured-overlay">
        <h1 className="featured-title" style={{ color: titleColour }}>{title}</h1>
        <div className="featured-media">
          {customContent ? (
            customContent
          ) : media && media.length > 0 ? (
            media.map((item, index) => {
              if (item.type === "youtube") {
                return (
                  <iframe
                    key={index}
                    width="560"
                    height="315"
                    src={`https://www.youtube.com/embed/${item.src}`}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                );
              } else if (item.type === "video") {
                return (
                  <video key={index} controls>
                    <source src={item.src} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                );
              } else {
                return <img key={index} src={item.src} alt={`Featured ${index}`} />;
              }
            })
          ) : (
            null
          )}
        </div>
      </div>
    </section>
  );
};

export default Featured;
